<template>
  <div v-if="isOpen">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6L12 12L6 18" stroke="#666666" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18 6L12 12L18 18" stroke="#6B7280" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <div v-else>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 9L12 15L6 9" stroke="#6B7280" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'IconChevron',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  setup () {
  }
}
</script>
